import React from 'react'
import { TextField, MenuItem, Typography, ListItemText } from '@material-ui/core'
import { TextFieldProps } from '@material-ui/core/TextField'

import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
  select: (props: { width: number }) => ({
    width: props.width,
    '& .MuiSelect-root': { display: 'flex', justifyContent: 'space-between', alignItems: 'center' }
  }),
  menu: {},
  listItemText: {}
}))

type SelectInputProps = {
  options: { value: any; label: string; caption: string }[]
  selectHandler: (select: string) => void
  width?: number
  required?: boolean
} & TextFieldProps

const SelectInputCategory: React.FC<SelectInputProps> = props => {
  const { value, label, selectHandler, options, width, fullWidth, required = false } = props
  const classes = useStyles({ width: width })
  return (
    <TextField
      className={classes.select}
      select
      label={label}
      value={value}
      onChange={(event: any) => selectHandler(String(event.target.value))}
      SelectProps={{
        MenuProps: {
          className: classes.menu
        }
      }}
      margin="normal"
      variant="outlined"
      fullWidth={fullWidth}
      required={required}
    >
      {options.map(option => (
        <MenuItem key={option.value} value={option.value}>
          <ListItemText
            primaryTypographyProps={{
              style: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }
            }}
          >
            {option.label}
          </ListItemText>
          {option.caption && (
            <Typography variant="caption" color="primary" style={{ marginLeft: 15 }}>
              {option.caption}
            </Typography>
          )}
        </MenuItem>
      ))}
    </TextField>
  )
}

export default SelectInputCategory
